module.exports = __webpack_public_path__ + "static/media/mito04.f3206625.jpg";